
<!-- lưới chi tiết -->
<div style="padding: 2px 10px 10px 10px;color:black !important; height: 200px">
  <div class="row">
    <table class="table table-striped table-bordered table-hover table-condensed">
      <thead [ngClass]="{'theadcss': totalItems>16}">
        <!--<thead>-->
        <tr>
          <th style="width:90px;text-align:center;background-color:#f3f8fc">STT</th>
          <th style="width:120px;text-align:center;background-color:#f3f8fc">Tên lớp</th>

          <th style="width:120px;text-align:center;background-color:#f3f8fc">Giáo viên</th>
          <th style="text-align:left;background-color:#f3f8fc">Ghi chú</th>
          <th style="width:200px;text-align:center;background-color:#f3f8fc">Chức năng</th>
        </tr>
      </thead>
      <tbody style="">
        <tr *ngFor="let u of datas">
          <td style="width:90px;text-align:center">{{u.STT}}</td>
          <td style="width:120px">{{u.TenLop}}</td>          
          <td style="width:120px">{{u.GiaoVien}}</td>
          <td>{{u.GhiChu}}</td>
          <td style="width:150px;text-align:center">
            <a href="#" class="mb-1 fas fa-exchange-alt ng2-smart-action ng-star-inserted" style="color:#1e6bb8 !important;margin-right:10px;" (click)="editdata(u)" title="Chuyển lớp">
              {{'Chuyển lớp' | translate}}
            </a>
            <a href="#" class="mb-1 far fa-trash-alt ng2-smart-action ng-star-inserted" style="color:#dc3545 !important;" (click)="deleterow(u)" title="Xóa khỏi lớp">
              {{'Xóa khỏi lớp' | translate}}
            </a>
          </td>
        </tr>
      </tbody>
    </table>


  </div>

</div>





<div class="modal-footer" style="display: flex;justify-content: space-between;margin-top:5px;">
  <div>
    <div *ngIf="totalItems>=10">
      <ul class="pagination">
        <li [ngClass]="{disabled: currentPage === 1}">
          <a (click)="setPage(1)"><<</a>
        </li>
        <li [ngClass]="{disabled:currentPage === totalPages}">
          <a (click)="setPage(currentPage + 1)">></a>
        </li>
        <li *ngFor="let page of pages" [ngClass]="{active: currentPage === page.Id}">
          <a (click)="setPage(page.Id)">{{page.Id}}</a>
        </li>
        <li [ngClass]="{disabled:currentPage === 1}">
          <a (click)="setPage(currentPage - 1)"><</a>
        </li>
        <li [ngClass]="{disabled:currentPage === totalPages}">
          <a (click)="setPage(totalPages)">>></a>
        </li>
        <li>
          <input type="number" style="width:50px;height:25px;text-align:center" [(ngModel)]="pageSize" (blur)="search1()" />
        </li>
        <li><span style="font-weight:bold">Tổng số: {{totalItems | number}}</span></li>
      </ul>
    </div>
  </div>
  <div class="">

  </div>

</div>


<div class="modal-footer" style="display: flex;justify-content: space-between;">
 
  <div class="">
    <button class="mb-1 mr-1 btn btn-secondary" (click)="save_chondoituong()" title="Ấn ESC để thoát" style="padding-top:0px !important">Đóng lại</button>
  </div>

</div>

<bs-modal #mdChuyenLopChoHocVien class="modal fade show in" [cssClass]="'modal7 top'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Chuyển lớp cho học sinh</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdChuyenLopChoHocVien.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-daotao-chuyenlopedit #chuyenlopedit (save)="saveModal($event)"></app-daotao-chuyenlopedit>
  </bs-modal-body>
</bs-modal>  





